// import { SimpleDispatcher } from "../simple_dispatcher";
import { FocusHandler } from "../focus_handlers";
import NodeHelper from "../helpers/node_helper";
import NodeHandler from "../node_handler";

class Modal extends NodeHandler { //focusable
    __init_dom_schema(){
        return {
            wrapper: {
                selector: '.modal__wrapper',
                actions: {
                    'click': function (event){
                        event.stopPropagation()
                        FocusHandler.Focus(null)
                        document.dispatchEvent(
                            new Event('click')
                        )
                    }
                }
            },
            holder: {
                selector: '.modal__holder',
                actions: {
                    'click': this.onClose.bind(this)
                }
            },
            buttons: {
                selector: '[data-action="close"]',
                is_single: false,
                actions: {
                    'click': this.onClose.bind(this),
                }
            },
        }
    }
    __init(){
        this.name = this.node.getAttribute('data-modal')

        // SimpleDispatcher.on(`${this.name}_open`, this.onOpen.bind(this))
        // SimpleDispatcher.on(`${this.name}_close`, this.onClose.bind(this))
    }
    onOpen(event){
        event.preventDefault()
        this.toggle(true)
    }
    onClose(event){
        event.preventDefault()
        this.toggle(false)
    }
    toggle(activate = null){
        NodeHelper.ToggleClass(this.node, 'is--active', activate)
    }
    focus(){
        // FocusHandler.Focus(this, 'modals')
    }
    unocus(){
        this.toggle(false)
    }
}

export default Modal;